import React from 'react';
import { IconPhoto } from '@tabler/icons-react';
import ImageUpload from '../ImageUpload';
import GalleryManager from '../GalleryManager';
import { FORM_CONSTANTS } from '../../constants/formConstants';

const Step4Media = ({ 
  formData, 
  setValue, 
  errors, 
  saving 
}) => {
  return (
    <div className="mpf-step-content">
      <div className="mpf-step-header">
        <IconPhoto size={24} className="text-primary" />
        <h4>Mídia</h4>
        <p className="text-muted">Imagem principal e galeria de imagens</p>
      </div>
      
      <ImageUpload
        label="Imagem Principal"
        value={formData.banner}
        onChange={(value) => setValue("banner", value)}
        error={errors.banner?.message}
        disabled={saving}
        maxSizeMB={FORM_CONSTANTS.MAX_BANNER_SIZE_MB}
        maxWidth={FORM_CONSTANTS.BANNER_RECOMMENDED_WIDTH}
        maxHeight={FORM_CONSTANTS.BANNER_RECOMMENDED_HEIGHT}
        helpText={`Imagem principal que aparecerá no card da publicação. Máximo ${FORM_CONSTANTS.MAX_BANNER_SIZE_MB}MB. Recomendado: ${FORM_CONSTANTS.BANNER_RECOMMENDED_WIDTH}x${FORM_CONSTANTS.BANNER_RECOMMENDED_HEIGHT}px`}
      />
      
      <GalleryManager
        label="Galeria de Imagens"
        value={formData.gallery_images}
        onChange={(value) => setValue("gallery_images", value)}
        error={errors.gallery_images?.message}
        disabled={saving}
        maxImages={FORM_CONSTANTS.MAX_GALLERY_IMAGES}
        maxSizeMB={FORM_CONSTANTS.MAX_GALLERY_SIZE_MB}
      />
    </div>
  );
};

export default Step4Media;